import { useQuery } from '@tanstack/react-query';
import { fetchUserMePermits } from './api';

export const useUserMePermitsQuery = (enabled: boolean = true) =>
  useQuery({
    queryKey: ['userMePermits'],
    queryFn: () => fetchUserMePermits(),
    enabled,
  });
